import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Sidebar from './components/Sidebar'
import Header from './components/Header'
import Dashboard from './pages/Dashboard'
import TestSubscription from './pages/TestSubscription'
import ContentTools from './pages/ContentTools'
import LearningTools from './pages/LearningTools'
import AssistantTools from './pages/AssistantTools'
import CreativeTools from './pages/CreativeTools'
import UtilityTools from './pages/UtilityTools'
import LandingPage from './pages/LandingPage'
import ProtectedApp from './components/ProtectedApp'
import './App.css'

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <Router>
      <Routes>
        {/* Public Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Protected App Routes - All require authentication + subscription */}
        <Route path="/app/*" element={
          <ProtectedApp>
            <div className="app">
              <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
              <div className="main-content">
                <Header onMenuClick={() => setSidebarOpen(true)} />
                <main className="content">
                  <Routes>
                    <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="content" element={<ContentTools />} />
                    <Route path="learning" element={<LearningTools />} />
                    <Route path="assistant" element={<AssistantTools />} />
                    <Route path="creative" element={<CreativeTools />} />
                    <Route path="utility" element={<UtilityTools />} />
                  </Routes>
                </main>
              </div>
            </div>
          </ProtectedApp>
        } />
        
        {/* Subscription Management - Requires auth but not subscription */}
        <Route path="/test-subscription" element={<TestSubscription />} />
        
        {/* Redirect old routes to new structure */}
        <Route path="/dashboard" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="/content" element={<Navigate to="/app/content" replace />} />
        <Route path="/learning" element={<Navigate to="/app/learning" replace />} />
        <Route path="/assistant" element={<Navigate to="/app/assistant" replace />} />
        <Route path="/creative" element={<Navigate to="/app/creative" replace />} />
        <Route path="/utility" element={<Navigate to="/app/utility" replace />} />
      </Routes>
    </Router>
  )
}

export default App 